//主系统接口
import request from '@/utils/request'

let baseUrl: any = {
  'development': '',
  'production': process.env.VUE_APP_MAIN_URL,
  'pst': process.env.VUE_APP_MAIN_URL,
}

export const Identity_PreLogin = (data: any) =>
  request({
    //@ts-ignore
    url: baseUrl[process.env.NODE_ENV] + '/api/MainSystem/Identity/PreLogin',
    method: 'post',
    data
  })

export const Identity_GetLoginOptions = (data: any) =>
  request({
    //@ts-ignore
    url: baseUrl[process.env.NODE_ENV] + '/api/MainSystem/Identity/GetLoginOptions',
    method: 'post',
    data
  })

export const Application_GetAll = (params: any) =>
  request({
    //@ts-ignore
    url: baseUrl[process.env.NODE_ENV] + '/api/MainSystem/Admin/Application/GetAll',
    method: 'post',
    params
  })

export const Identity_Login = (data: any) =>
  request({
    //@ts-ignore
    url: baseUrl[process.env.NODE_ENV] + '/api/MainSystem/Identity/Login',
    method: 'post',
    data
  })

export const Identity_ChangePwd = (data: any) =>
  request({
    //@ts-ignore
    url: baseUrl[process.env.NODE_ENV] + '/api/MainSystem/Admin/User/ModifyPassWord', 
    method: 'post',
    data
  })

  export const Identity_Power = (data: any) =>
  request({
    //@ts-ignore
    url: baseUrl[process.env.NODE_ENV] + '/api/MainSystem/Identity/GetUserIsolatePrivilege', 
    method: 'post',
    data
  })

  export const Identity_SwitchLogin = (data: any) =>
  request({
    //@ts-ignore
    url: baseUrl[process.env.NODE_ENV] + '/api/MainSystem/Identity/SwitchLogin', 
    method: 'post',
    data
  })